import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProvidersListComponent } from './providers-list.component';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { SharedModule } from '../shared.module';
import { MaskAccountNumberModule } from '@pipes/mask-account-number/mask-account-number.module';

@NgModule({
  declarations: [ProvidersListComponent],
  imports: [
    SharedModule,
    MatSelectModule,
    FormsModule,
    MaskAccountNumberModule,
  ],
  exports: [ProvidersListComponent],
})
export class ProvidersListModule {}
